(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-desc"] && !Shopify.designMode) return;
  try {
    
    //   $(document).ready(function(){
    //     $(".accordion-btn").click(function () {
    //         $(".accordion-btn").removeClass('on')
    //         $(this).addClass("on")
    //         $('.accordion-paragraph').slideUp();
    //         $(this).next().slideDown();
    //     });
    //     $(".accordion-btn").first().addClass("on")
    //     $(".accordion-btn").eq(0).addClass("on")
    //     $(".accordion-btn.on").next(".accordion-paragraph").css('display', 'block')
    // });
    $(document).ready(function(){
    $(".accordion-btn").click(function () {
      $(this).toggleClass("on").next().slideToggle();
      $(".accordion-btn").not(this).removeClass('on').next().slideUp();
    });

    // Expand the first accordion item by default
    $(".accordion-main .accordion-btn:first-child").first().addClass("on").next().slideDown();
  });

  } catch(e) { console.error(e); }
})();
})();
